import { useEpisodes } from "@/contexts/EpisodesContext";
import { useMentionCards } from "@/contexts/MentionCardsContext";
import useFilterParams from "@/hooks/useFilterParams";
import {
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  EmptyDescription,
  EmptyContent,
  Empty,
} from "@components/ui/empty";
import { Trans } from "@lingui/react/macro";
import { Button } from "@components/ui/button";

export default function FilteredEmpty({ v4 = false }: { v4?: boolean }) {
  const [{ tag }, setFilters] = useFilterParams();
  const legacyEpisodesResult = useEpisodes();
  const mentionCardsResult = useMentionCards();

  const alert = v4 ? mentionCardsResult.alert : legacyEpisodesResult.alert;

  return (
    <Empty data-testid="filter-no-mentions">
      <EmptyHeader>
        <EmptyMedia></EmptyMedia>
        <EmptyTitle>
          <Trans>Inga omnämnanden</Trans>
        </EmptyTitle>
        <EmptyDescription>
          <Trans>Det finns inga träffar som matchar din sökning.</Trans>
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button
          variant="outline"
          onClick={(e: unknown) => {
            (e as MouseEvent).preventDefault();
            setFilters(
              { tag, start_date: tag ? undefined : alert?.start_date },
              true
            );
          }}
        >
          <Trans>Nollställ filtret</Trans>
        </Button>
      </EmptyContent>
    </Empty>
  );
}
